<template>
  <div class="buy-feature">
    <TitleLabel :title="`${rightsName}-${feature.name} ${$t('jia-gou')}`" />
    <div class="buy-feature__desc">
      <div v-for="desc in feature.desc" :key="desc">
        {{ desc }}
      </div>
    </div>
    <div class="buy-feature__block">
      <TeamBuy
        v-if="userInfo?.rights_type === USER_LEVEL_KEY.TEAM_LIGHT"
        :picked="pickedPackage"
        :packages="packages"
        :rightsName="rightsName"
        @change="handlePick"
      />
      <PersonalBuy
        v-else
        :packages="packages"
        :picked="pickedPackage"
        @change="handlePick"
      />
    </div>
  </div>
</template>

<script setup lang="ts" name="BuyFeature">
import TitleLabel from '../titleLabel/index.vue'
import PersonalBuy from './personal.vue'
import TeamBuy from './team.vue'
import { RightsFeature } from '~/constants'
import { getRightsCreditCoinsPackage, type ICreditCoinsPackage } from '~/api'
import { RIGHTS_FEATURE } from '~/api/interface/rights'
import { USER_LEVEL_KEY } from '~/api/interface'

const props = withDefaults(
  defineProps<{
    packageInfo?: ICreditCoinsPackage
    rightsName: string
    featureType: RIGHTS_FEATURE
    unitPrice: number
    days?: number
  }>(),
  {
    days: 0,
  }
)
const { $t } = useNuxtApp()

const userInfo = useUserInfo()
const emits = defineEmits(['update:packageInfo'])
const pickedPackage = ref<ICreditCoinsPackage>()

const handlePick = (item: ICreditCoinsPackage) => {
  pickedPackage.value = item
  emits('update:packageInfo', item)
}

const coinsPackages = await useAsyncData(() =>
  getRightsCreditCoinsPackage({
    many: '1',
    rights_type: userInfo.value!.rights_type,
  })
)

handlePick(coinsPackages.data.value!.data![0])

const packages = computed(() => {
  return coinsPackages.data.value?.data || []
})

const feature = computed(() => RightsFeature()[props.featureType])
</script>

<style lang="scss" scoped>
.buy-feature {
  @apply w-full p-[30px];

  &__desc {
    padding-top: 16px;
    color: var(--text-1);
    font-size: 14px;
    line-height: 24px;
    opacity: 0.6;
  }
  &__block {
    margin-top: 30px;
    // column-gap: 20px;
    &--label {
      width: 48px;
      opacity: 0.6;
    }
  }
}
</style>
